import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@mui/material'

import './style.scss'

/**
 * Defines the number of view section:
 *  - ONE_SECTION    >> only the central part is visible.
 *  - TWO_SECTION    >> only the central part and left or right section are visible.
 *  - THREE_SECTION  >> all the sections are visible: left, center and right.
 *
 * This feature is used to resize page to fit all the content.
 */
export const PageNumSections = {
  ONE_SECTION: 'oneSection',
  TWO_SECTIONS: 'twoSections',
  THREE_SECTIONS: 'threeSections'
}

export const PageCenter = ({ numSections, className, children }) => (
  <Grid item={true} xs={12} className={`commonPage_container_central ${numSections} ${className}`}>
    {children}
  </Grid>
)

PageCenter.displayName = 'PageCenter'

PageCenter.propTypes = {
  numSections: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node.isRequired
}

PageCenter.defaultProps = {
  numSections: 'oneSection',
  className: ''
}
